module.exports = __webpack_public_path__ + "img/f2.5dbd5e7b.png";